import { render, staticRenderFns } from "./LivesDisplay.vue?vue&type=template&id=43601282&scoped=true&"
import script from "./LivesDisplay.vue?vue&type=script&lang=js&"
export * from "./LivesDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LivesDisplay.vue?vue&type=style&index=0&id=43601282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43601282",
  null
  
)

export default component.exports